/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageMetadata } from './page-metadata';
import { ServizioMensaRendicontazioneReportRowDTO } from './servizio-mensa-rendicontazione-report-row-dto';


export interface PagedModelServizioMensaRendicontazioneReportRowDTO { 
    content?: Array<ServizioMensaRendicontazioneReportRowDTO>;
    page?: PageMetadata;
}

